import { IAddress } from "./types";

export function getAddress(address: IAddress) : string {
    return `${address.addressLine1}, ${address.postalCode} ${address.city}`
}

export function hasAddress(address: IAddress) : boolean {
    return address.addressLine1 !== undefined && address.addressLine1 !== null;
}